export const DEFAULT_UNCATEGORISED_ID = 0;
export const DEFAULT_UNCATEGORISED_NAME = 'Other';
export const STD_PERS_LABEL_MAX_LIMIT = 500;
export const DEFAULT_GROUP_ID = -1;
export const DEFAULT_GROUP_NAME = 'Groups';
export const LABEL_MAX_LIMIT = 100;
export const PERS_TOAST_MSG = `To optimize performance, only the first LABEL_MAX_LIMIT labels/categories from your database were added.`;
